import { Size } from './size';

const DEFAULT_VIEWPORT_PADDING = 30;

export class ViewportSize implements Size {

  get width(): number {
    return this._width - (2 * this.padding);
  }

  get height(): number {
    return this._height - (2 * this.padding);
  }

  constructor(
    private readonly _width: number,
    private readonly _height: number,
    private readonly padding: number = DEFAULT_VIEWPORT_PADDING
  ) {
  }

  contains(size: Size): boolean {
    return this.width >= size.width && this.height >= size.height;
  }
}
